(() => {
  if (document.querySelector('[data-ci3d-contact-hub]')) return;
  const PROJECT_FORM_URL = 'https://quote.createit3d.co.za/?source=contact-centre';
  const SUPPORT_FORM_URL = '/pages/contact-us#ci3d-support-intake';
  const SALES_EMAIL_URL = 'mailto:sales@createit3d.co.za?subject=Create%20It%203D%20sales%20enquiry';

  const enhanceHero = () => {
    const heading = document.querySelector('main h1');
    const section = heading?.closest('.shopify-section');
    const content = heading?.parentElement;
    const paragraph = content?.querySelector('p');
    const image = section?.querySelector('img');

    if (!heading || !section || !content || section.dataset.ci3dContactHero === 'true') return false;
    section.dataset.ci3dContactHero = 'true';
    section.classList.add('ci3d-contact-hero');

    heading.textContent = 'Tell us once. We’ll get it to the right team.';
    if (paragraph) {
      paragraph.classList.add('ci3d-contact-hero__lede');
      paragraph.textContent = 'Sales and project enquiries go directly to sales. Existing orders, payments, warranty and technical requests go directly to support.';
    }
    if (image) {
      image.alt = 'Create It 3D manufacturing, product sales and technical support';
      image.loading = 'eager';
      image.fetchPriority = 'high';
    }

    const eyebrow = document.createElement('p');
    eyebrow.className = 'ci3d-contact-hero__eyebrow';
    eyebrow.textContent = 'CREATE IT 3D · CLEAR ENQUIRY ROUTING';
    content.insertBefore(eyebrow, heading);

    const actions = document.createElement('div');
    actions.className = 'ci3d-contact-hero__actions';
    actions.innerHTML = `
      <a class="ci3d-button ci3d-button--primary" href="${PROJECT_FORM_URL}">
        Start a sales or project brief
        <span class="material-symbols-rounded" aria-hidden="true">arrow_forward</span>
      </a>
      <a class="ci3d-button ci3d-button--secondary" href="${SUPPORT_FORM_URL}">Get support</a>
    `;
    content.appendChild(actions);

    const proof = document.createElement('div');
    proof.className = 'ci3d-contact-hero__proof';
    proof.setAttribute('aria-label', 'Contact service benefits');
    proof.innerHTML = `
      <span><span class="material-symbols-rounded" aria-hidden="true">alternate_email</span>Correct inbox first time</span>
      <span><span class="material-symbols-rounded" aria-hidden="true">attachment</span>Secure file uploads</span>
      <span><span class="material-symbols-rounded" aria-hidden="true">public</span>Nationwide assistance</span>
    `;
    content.appendChild(proof);
    return true;
  };

  const replaceLegacyIntro = () => {
    const heading = [...document.querySelectorAll('main h2')]
      .find((item) => item.textContent.trim().replace(/[’']/g, "'") === "Let's Talk About Your Project");
    const section = heading?.closest('.shopify-section');
    if (!section || section.dataset.ci3dContactIntro === 'true') return false;

    section.dataset.ci3dContactIntro = 'true';
    section.classList.add('ci3d-contact-options');
    section.innerHTML = `
      <div class="page-width ci3d-contact-options__inner">
        <div class="ci3d-contact-options__heading">
          <p>THE RIGHT ROUTE, FIRST TIME</p>
          <h2>What do you need help with?</h2>
          <span>Choose the closest route. Each option goes directly to the responsible Create It 3D inbox.</span>
        </div>
        <div class="ci3d-contact-options__grid">
          <article>
            <span class="material-symbols-rounded" aria-hidden="true">shopping_bag</span>
            <h3>Product sales and quotations</h3>
            <p>Product advice, availability, compatibility, quotations and proforma invoice requests.</p>
            <a href="${SALES_EMAIL_URL}">Email sales@createit3d.co.za <span aria-hidden="true">→</span></a>
          </article>
          <article class="ci3d-contact-options__featured">
            <span class="material-symbols-rounded" aria-hidden="true">precision_manufacturing</span>
            <h3>Custom service or manufacturing quote</h3>
            <p>3D printing, scanning, CAD, reverse engineering, laser work and production projects with secure file uploads.</p>
            <a href="${PROJECT_FORM_URL}">Start the detailed brief <span aria-hidden="true">→</span></a>
          </article>
          <article>
            <span class="material-symbols-rounded" aria-hidden="true">support_agent</span>
            <h3>Orders, payments and support</h3>
            <p>Proof of payment, paid orders, delivery, returns, warranty, account and technical support.</p>
            <a href="${SUPPORT_FORM_URL}">Open the support form <span aria-hidden="true">→</span></a>
          </article>
        </div>
      </div>
    `;
    return true;
  };

  const run = () => {
    const heroReady = enhanceHero() || document.querySelector('[data-ci3d-contact-hero="true"]');
    const optionsReady = replaceLegacyIntro() || document.querySelector('[data-ci3d-contact-intro="true"]');
    return Boolean(heroReady && optionsReady);
  };

  if (!run()) {
    const observer = new MutationObserver(() => {
      if (run()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  }
})();

